module.exports = __webpack_public_path__ + "assets/img/37_1593.52cff27c.jpg";